<!-- Private Layout - For authenticated users and admin using SB Admin template -->
<div class="private-layout-container">

  <!-- Start of SB Admin Dashboard Layout -->
  <div class="dashboard-layout-main">

    <!-- Top Navigation Bar -->
    <app-nav-menu></app-nav-menu>
    

    <!-- Main Layout Container -->
    <div id="layoutSidenav">

      <!-- Left Sidebar Navigation - Only show for admin routes -->
      <div id="layoutSidenav_nav" class="primary-dark-bg side-nav-dashboard-container" *ngIf="showAdminNav">
        <admin-panel-nav></admin-panel-nav>
      </div>   

      <!-- Main Content Area -->
      <div id="layoutSidenav_content" [class.full-width]="!showAdminNav">
        <div class="content-wrapper">
          <main>
            <div class="container-fluid px-4 py-4">
              <!-- Child routes will render here (dashboard, classes, admin pages, etc.) -->
              <router-outlet></router-outlet>
            </div>
          </main>
          
            
            
        </div>
        
      </div>
      

    </div>
    <!-- Footer - Inside scrollable content -->
    <!-- <app-footer></app-footer> -->

  </div>


</div>